/* Progressive enhancement: without JavaScript both product photos remain visible. */
if (!customElements.get('eb-fragrance-gallery')) {
  class EBFragranceGallery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      this.thumbnails = [...this.querySelectorAll('[data-gallery-index]')];
      this.status = this.querySelector('[data-gallery-status]');
      this.dialog = this.querySelector('[data-gallery-dialog]');
      if (this.slides.length < 2) return;

      this.index = 0;
      this.dataset.ready = 'true';
      this.show(0);
      this.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-gallery-index]');
        if (thumbnail) this.show(Number(thumbnail.dataset.galleryIndex));
        if (event.target.closest('[data-gallery-next]')) this.show(this.index + 1);
        if (event.target.closest('[data-gallery-prev]')) this.show(this.index - 1);
        const enlarge = event.target.closest('[data-gallery-enlarge]');
        if (enlarge && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
          if (typeof this.dialog?.showModal !== 'function') return;
          event.preventDefault();
          const original = enlarge.querySelector('img');
          const image = this.querySelector('[data-gallery-dialog-image]');
          image.src = original.currentSrc || original.src;
          image.alt = original.alt;
          this.returnFocus = enlarge;
          this.dialog.showModal();
        }
        if (event.target.closest('[data-gallery-close]')) this.dialog?.close();
      }, options);

      this.addEventListener('keydown', (event) => {
        if (this.dialog?.open || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.index + (event.key === 'ArrowRight' ? 1 : -1);
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.slides.length - 1;
        const fromThumbnail = event.target.closest('[data-gallery-index]');
        const fromImage = event.target.closest('[data-gallery-enlarge]');
        this.show(index);
        if (fromThumbnail) this.thumbnails[this.index].focus();
        if (fromImage) this.slides[this.index].querySelector('a').focus();
      }, options);

      const stage = this.querySelector('.eb-gallery__stage');
      stage.addEventListener('touchstart', (event) => {
        this.touchStart = event.touches.length === 1 ? {
          x: event.touches[0].clientX, y: event.touches[0].clientY
        } : null;
      }, { ...options, passive: true });
      stage.addEventListener('touchend', (event) => {
        if (!this.touchStart || !event.changedTouches[0]) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.show(this.index + (dx < 0 ? 1 : -1));
        }
      }, { ...options, passive: true });
      stage.addEventListener('touchcancel', () => { this.touchStart = null; }, options);

      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog?.addEventListener('close', () => {
        this.returnFocus?.focus();
      }, options);
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.thumbnails.forEach((button, i) => {
        button.setAttribute('aria-pressed', String(i === this.index));
      });
      const zh = document.documentElement.lang.toLowerCase().startsWith('zh');
      this.status.textContent = `${this.index + 1} / ${this.slides.length} — ${this.index === 0 ? (zh ? '香水瓶' : 'Bottle') : (zh ? '场景' : 'The setting')}`;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.dialog?.close();
    }
  }
  customElements.define('eb-fragrance-gallery', EBFragranceGallery);
}
